export default {
  lang: {
    selectAll: 'Seleccionar todo como página',
    selected: 'Selectado',
    term: 'Artículo',
    deselect: 'Cancelar la selección',
  },
};
